const Bos = {
  symbol: 'bos',
  color: '#000',
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" r="16" fill="#00A8D6"/><path fill="#FFF" d="M14.432 18.95v-1.917h2.954c1.97 0 2.955-.492 2.955-1.476v-5.164c0-.983-.985-1.475-2.955-1.475H12.66v3.098H10V7h7.09C21.03 7 23 8.082 23 10.246v5.459c0 2.164-1.97 3.246-5.91 3.246h-2.658zm5.909 1.181H23v1.623C23 23.918 21.03 25 17.09 25H10V13.492h7.09c.417 0 .81.012 1.183.036v1.921a9.18 9.18 0 00-.887-.04H12.66v7.673h4.727c1.97 0 2.955-.492 2.955-1.475V20.13z"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" fill-rule="evenodd" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-1.568-13.05h2.659c3.94 0 5.909-1.081 5.909-3.245v-5.46C23 8.083 21.03 7 17.09 7H10v5.016h2.66V8.918h4.726c1.97 0 2.955.492 2.955 1.475v5.164c0 .984-.985 1.476-2.955 1.476h-2.954v1.918zm5.909 1.181v1.476c0 .983-.985 1.475-2.955 1.475H12.66V15.41h4.727c.322 0 .618.013.887.04v-1.922a18.301 18.301 0 00-1.182-.036H10V25h7.09c3.94 0 5.91-1.082 5.91-3.246v-1.623h-2.66z"/>`;
  }
};
export default Bos;
